<template>
  <div class="task-template">
    <header class="top-wrap">
      <div class="main-title">任务类型</div>
      <div class="right">
        <div class="mRight10">
          <el-input
            v-model="searchText"
            size="small"
            placeholder="搜索任务类型"
            clearable
            @keyup.native.enter="search"
            @clear="search"
          >
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </div>
        <el-button type="primary" size="small" @click="taskTypeVisible = true">新建</el-button>
      </div>
    </header>
    <main class="main-wrap">
      <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
      <BaseTable
        v-else
        ref="baseTable"
        tableHeight="100%"
        :tableColumns="tableColumns"
        :tableData="filterData"
        :pageInfo="pageInfo"
      >
        <template v-slot:table-suffix>
          <el-table-column width="180" align="center">
            <template v-slot="scope">
              <el-button @click.stop="toSetWorkFlow(scope.row)" type="text" size="mini">
                设置审批
              </el-button>
              <el-button
                v-if="scope.row.workflowId"
                @click.stop="removeWorkFlow(scope.row)"
                type="text"
                size="mini"
              >
                删除审批
              </el-button>
              <template v-if="!scope.row.default">
                <el-button @click.stop="removeTaskType(scope.row)" type="text" size="mini">
                  删除
                </el-button>
              </template>
            </template>
          </el-table-column>
        </template>
      </BaseTable>
    </main>
    <task-type-dialog :visible.sync="taskTypeVisible" @submit="addTaskType"></task-type-dialog>
    <approval-workflow-dialog
      :visible.sync="approvalWorkflowVisible"
      @submit="setWorkflow"
    ></approval-workflow-dialog>
  </div>
</template>

<script>
import BaseTable from "@/components/BaseComponents/Table"
import ApprovalWorkflowDialog from "./ApprovalWorkflowDialog"
import TaskTypeDialog from "./TaskTypeDialog"
import { templateTableColumns as tableColumns } from "../static"
import * as projectApi from "@/api/project/project"
import { loadingService } from "@/utils/ui"
import { stringIncludes } from "@/utils/common"

export default {
  name: "task-template",
  components: { BaseTable, ApprovalWorkflowDialog, TaskTypeDialog },
  data() {
    return {
      tableColumns,
      showTable: false,
      taskTypeList: [],
      filterData: [],
      pageInfo: {
        total: 100,
        currentPage: 1,
        pageSize: 20
      },
      projectId: this.$route.params.projectId,
      searchText: "",
      taskTypeVisible: false,
      approvalWorkflowVisible: false,
      currentTaskType: null
    }
  },
  watch: {
    "filterData.length": function(newVal) {
      this.pageInfo.total = newVal
    }
  },
  created() {
    this.getTaskTypeListByProject()
  },
  methods: {
    getTaskTypeListByProject() {
      this.showTable = false
      return projectApi.getTaskTypeListByProject(this.projectId).then(res => {
        this.taskTypeList = res.map(row => {
          let taskType = row.taskType
          if (!taskType) taskType = { name: "默认", default: true }
          else if (taskType.appName && taskType.sheetName) {
            taskType.sheetStr = taskType.appName + " / " + taskType.sheetName
          }
          Object.assign(taskType, {
            taskTypeId: row.taskTypeId,
            workflowId: row.workflowId,
            workflowName: row.workflowName
          })
          return taskType
        })
        this.filterData = this.taskTypeList
        this.showTable = true
      })
    },
    search() {
      this.filterData = this.taskTypeList.filter(i => stringIncludes(i.name, this.searchText))
    },
    toSetWorkFlow(row) {
      this.currentTaskType = row
      this.approvalWorkflowVisible = true
    },
    addTaskType(rows) {
      let taskTypeIdList = rows.map(i => i.id)
      if (taskTypeIdList.length == 0) return
      let loadingInstance = loadingService()
      projectApi
        .addTaskTypeListToProject(taskTypeIdList, this.projectId)
        .then(res => {
          this.taskTypeVisible = false
          this.$message.success("添加成功")
          this.getTaskTypeListByProject()
        })
        .finally(() => loadingInstance.close())
    },
    removeTaskType(row) {
      this.$confirm("确认删除该任务模板？", "提示", {
        type: "warning"
      })
        .then(() => {
          let loadingInstance = loadingService()
          projectApi
            .removeProjectTaskType(row.id, this.projectId)
            .then(res => {
              this.$message.success("操作成功")
              this.getTaskTypeListByProject()
            })
            .finally(() => loadingInstance.close())
        })
        .catch(() => {
          return
        })
    },
    removeWorkFlow(row) {
      this.$confirm("确认删除该任务的审批工作流？", "提示", {
        type: "warning"
      })
        .then(() => {
          this.currentTaskType = row
          this.setWorkflow()
        })
        .catch(() => {
          return
        })
    },
    setWorkflow(workFlow) {
      let loadingInstance = loadingService()
      let workFlowId = workFlow?.id || ""
      projectApi
        .setTaskTypeDefWorkflow(this.currentTaskType.id, this.projectId, workFlowId)
        .then(res => {
          this.approvalWorkflowVisible = false
          this.$message.success("设置成功")
          this.getTaskTypeListByProject()
        })
        .finally(() => loadingInstance.close())
    }
  }
}
</script>

<style lang="scss" scoped>
.task-template {
  .right ::v-deep {
    .el-input-group__append {
      padding: 0 10px;
    }
  }
  .main-wrap {
    height: calc(100% - 56px) !important;
    ::v-deep .base-table .pagination {
      margin-top: 6px !important;
    }
  }
}
</style>
